// extracted by mini-css-extract-plugin
export default {"like":"_2ebKN","not-clickable":"_12VpJ","notClickable":"_12VpJ","likebutton":"_1JKbH","likes":"_3y07O"};